/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createnewbusiness2Inputs */

const en_createnewbusiness2 = /** @type {(inputs: Createnewbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Business`)
};

const de_createnewbusiness2 = /** @type {(inputs: Createnewbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Unternehmen erstellen`)
};

/**
* | output |
* | --- |
* | "Create New Business" |
*
* @param {Createnewbusiness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createnewbusiness2 = /** @type {((inputs?: Createnewbusiness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createnewbusiness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createnewbusiness2(inputs)
	return de_createnewbusiness2(inputs)
});
export { createnewbusiness2 as "createNewBusiness" }